import { useState } from 'react';

import FilterAltIcon from '@mui/icons-material/FilterAlt';
import {
    Button, Fade, IconButton, Menu, MenuItem
} from '@mui/material';

const PeriodSelector = ({
    options,
    value,
    onChange,
    label = 'Filtrar',
    icon = <FilterAltIcon />,
    iconOnly = false,
    menuId = 'dashboard-period-menu',
    ariaLabel = 'Seleccionar periodo'
}) => {
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);

    const closeMenu = () => setAnchorEl(null);

    const selectOption = (option) => {
        onChange(option.value, option);
        closeMenu();
    };

    const triggerProps = {
        'aria-label': ariaLabel,
        'aria-controls': open ? menuId : undefined,
        'aria-expanded': open ? 'true' : undefined,
        'aria-haspopup': 'true',
        onClick: event => setAnchorEl(event.currentTarget)
    };

    return (
        <>
            {
                iconOnly
                    ? <IconButton {...triggerProps}>{icon}</IconButton>
                    : (
                        <Button color="primary" startIcon={icon} {...triggerProps}>
                            {label}
                        </Button>
                    )
            }
            <Menu
                id={menuId}
                anchorEl={anchorEl}
                open={open}
                onClose={closeMenu}
                TransitionComponent={Fade}
            >
                {
                    options.map(option => (
                        <MenuItem
                            key={option.value}
                            selected={option.value === value}
                            onClick={() => selectOption(option)}
                        >
                            {option.label}
                        </MenuItem>
                    ))
                }
            </Menu>
        </>
    );
};

export default PeriodSelector;
